import React from 'react';
import { Box, Typography, Chip, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MediaPreview from '../utils/MediaPreview';

export default function ReportCard({ report }) {
    const navigate = useNavigate();
      const theme = useTheme();
    
      const getStatusColor = (status) => {
        if (status === 'Verified') return 'success';
        if (status === 'Pending') return 'warning';
        return 'error';
      };
    
  return (
    <Box
            key={report?.report_id}
            sx={{
              flexShrink: 0,
              width: {
                xs: '75vw', // for mobile
                sm: 260,
                md: 280,
                lg: 300,
              },
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 3,
              position: 'relative',
              scrollSnapAlign: 'start',
              cursor: 'pointer',
              '&:hover .overlay': {
                opacity: 1,
              },
            }}
            onClick={() => navigate(`/reports/${report.report_id}/details`)}
          >
            <MediaPreview
              src={report?.media_url}
              alt={report?.category || 'Report'}
            />

            {/* Status badge at top right */}
            <Chip
              label={report.status}
              size="small"
              color={getStatusColor(report.status)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                fontWeight: 'bold',
                zIndex: 2,
              }}
            />

            {/* Description overlay */}
            <Box
              className="overlay"
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                bgcolor: 'rgba(0,0,0,0.6)',
                color: '#fff',
                px: 1.5,
                py: 1,
                opacity: 1,
                transition: 'opacity 0.3s ease-in-out',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 10,
                  mt: 0.5,
                  whiteSpace: 'pre-wrap',
                  lineHeight: 1.4,
                }}
              >
                {report.description?.length > 50
                  ? report.description.slice(0, 50) + '...'
                  : report.description}
              </Typography>
              <Typography
                variant="caption"
                sx={{ mt: 0.5, display: 'block', fontSize: 11, opacity: 0.8 }}
              >
                Reported on: <b>{report.timestamp
                  ? new Date(report.timestamp).toLocaleDateString()
                  : 'N/A'}</b>
                
              </Typography>
            </Box>
          </Box>
  )
}
